
//1.Import
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import Navbar from './Navbar'
import PageHeader from '../sections/PageHeader'
import Footer from '../sections/Footer'
import Lazyimg from './Lazyimg';
import OverlapSection from './OverlapSection';
import ImageParallax from './ImageParallax';
import CustomModal from './CustomModal'

//2.Initialization
gsap.registerPlugin(ScrollTrigger,ScrollSmoother);
const pageHeader=new PageHeader();
const footer=new Footer();
const lazyimg=new Lazyimg();
const imageParallax=new ImageParallax();
const overlapSection=new OverlapSection();
const navbar=new Navbar();
const customModal=new CustomModal();
class App {
    constructor() {
        customModal.events();
        navbar.events();
        lazyimg.init();
        imageParallax.init();
        overlapSection.init();
        let tlGlobal = gsap.timeline();
        tlGlobal
        .add(navbar.animate())
        .add(pageHeader.animate()) 
        footer.init();
        this.initScrollSmooth();
    }

    initScrollSmooth(){
        let scroller;
        if (ScrollTrigger.isTouch !== 1) {
            scroller=ScrollSmoother.create({
                smooth: 1,// how long (in seconds) it takes to "catch up" to the native scroll position
                effects: true,// looks for data-speed and data-lag attributes on elements
            });
        }
        return scroller
    }
}
export default App

